import { memo, useId } from 'react'
import Icon from '../Icon'
import Text from '../Text'

import * as Styled from './styled'
import CheckIcon from 'assets/svgr-icons/Check.svg'
import { CheckboxSize } from './consts'

export interface ICheckboxProps {
  isChecked?: boolean
  onChange?: (
    nextChecked: boolean,
    event: React.ChangeEvent<HTMLInputElement>
  ) => void
  label?: React.ReactNode
  className?: string
  isDisabled?: boolean
  name?: string
  id?: string
  size?: CheckboxSize
}

const Checkbox: React.FC<ICheckboxProps> = props => {
  const {
    isChecked = false,
    onChange,
    label,
    className,
    isDisabled = false,
    name,
    id,
    size = CheckboxSize.md
  } = props

  const autoId = useId()
  const inputId = id ?? autoId

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange?.(e.target.checked, e)
  }

  return (
    <Styled.LabelWrapper
      className={className}
      $isDisabled={isDisabled}
      htmlFor={inputId}
    >
      <Styled.HiddenCheckbox
        id={inputId}
        name={name}
        type="checkbox"
        checked={isChecked}
        onChange={handleChange}
        disabled={isDisabled}
      />
      <Styled.Box
        $isChecked={isChecked}
        $isDisabled={isDisabled}
        $size={size}
        aria-hidden
      >
        <Icon icon={<CheckIcon />} size="medium" color="white" />
      </Styled.Box>
      {label && <Text type="h4">{label}</Text>}
    </Styled.LabelWrapper>
  )
}

export default memo(Checkbox)
